import React from "react";
import useStyles from "../AppPageTable/styles";
import clsx from "clsx";

export interface Props {
  children?: React.ReactNode;
  rootRef?: React.RefObject<HTMLDivElement>;
  className?: string;
  role?: string;
}

const AppPageTable = (props: Props) => {
  const { children, className, rootRef } = props;
  const classes = useStyles();

  return (
    <div
      ref={rootRef}
      className={clsx(classes.appPageTable, className)}
      role="table"
    >
      {children}
    </div>
  );
};

export default AppPageTable;
